function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

class LightBoxTrigger extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.openLightBox.bind(this));

    this.lightbox = document.querySelector('light-box.mp4');
  }

  openLightBox(event) {
    const url = event.currentTarget.dataset.video;
    this.lightbox.open(url);
  }
}

customElements.define('light-box-trigger', LightBoxTrigger);

class LightBox extends HTMLElement {
  constructor() {
    super();

    this.lightbox = this.querySelector('.lightbox');
    this.overlay = this.querySelector('.lightbox__overlay');
    this.video = this.querySelector('video');

    this.lightbox.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  open(url) {
    this.lightbox.setAttribute('aria-hidden', false);
    this.overlay.addEventListener('click', this.close.bind(this));

    if (url) {
      this.playVideo(url);
    }
  }

  close() {
    this.lightbox.setAttribute('aria-hidden', true);
    pauseAllMedia();
  }

  playVideo(url) {
    this.video.setAttribute('src', url);
    this.video.currentTime = 0;
    this.video.play();
  }
}

customElements.define('light-box', LightBox);

/* ----- Dropdowns ----- */
// Benefits dropdowns
document.addEventListener("DOMContentLoaded", () => {
  const headers = document.querySelectorAll(".benefits__dropdown-header");

  headers.forEach(header => {
    header.addEventListener("click", () => {
      // Toggle active class on parent
      header.parentElement.classList.toggle("active");

      // Find the sibling with .benefits__dropdown-content
      const content = header.parentElement.querySelector(".benefits__dropdown-content");

      if (content) {
        // Slide toggle effect
        if (content.style.maxHeight) {
          content.style.maxHeight = null; // Collapse
        } else {
          content.style.maxHeight = content.scrollHeight + "px"; // Expand
        }
      }
    });
  });
});